/* This is the set of icons that can be used as waypoint symbols
 *
 * They are drawn with size=35px; the X and Y offsets are in pixels. A positive will shift the icon right or down.
 * Use the "pad" property to (partially) fill transparent areas with a white background
 * 
 * See: /node_modules/@mdi/font/preview.html for other icons and their codepoints
 */

export const WaypointIconSet: {[name: string]: {codePoint: number; xoffs: number; yoffs: number; pad: number}} = { 

    // Map markers
    
    'mdi-map-marker':               {codePoint: 0xF034E, xoffs:0, yoffs:-14, pad: 0},
    'mdi-map-marker-alert':         {codePoint: 0xF0F05, xoffs:0, yoffs:-14, pad: 0},
    'mdi-map-marker-check':	        {codePoint: 0xF0C95, xoffs:0, yoffs:-14, pad: 0},
    'mdi-map-marker-remove-variant':{codePoint: 0xF0F0A, xoffs:0, yoffs:-14, pad: 0},
    'mdi-map-marker-star':	        {codePoint: 0xF1608, xoffs:0, yoffs:-14, pad: 0},
    'mdi-map-marker-circle':	    {codePoint: 0xF034F, xoffs:0, yoffs:  0, pad: 0},
    'mdi-map-marker-question':	    {codePoint: 0xF0F07, xoffs:0, yoffs:-14, pad: 0},
    'mdi-alert-circle':	            {codePoint: 0xF0028, xoffs:0, yoffs:  0, pad: 0},
    'mdi-alert':	                {codePoint: 0xF0026, xoffs:0, yoffs:  0, pad: 0},
    'mdi-crosshairs-gps':           {codePoint: 0xF01A4, xoffs:0, yoffs:  0, pad: 0},
    
    // Clocks & timers
    
    'mdi-clock':	                {codePoint: 0xF0954, xoffs:0, yoffs:0, pad: 0},
    'mdi-timer':	                {codePoint: 0xF13AB, xoffs:0, yoffs:0, pad: 0},
    
    // Route splits & joins
    
    'mdi-call-split':	            {codePoint: 0xF00FB, xoffs:0, yoffs:0, pad: 0},
    'mdi-call-merge':	            {codePoint: 0xF00F8, xoffs:0, yoffs:0, pad: 0},
    
    // Maintenance, Mechanics
    
    'mdi-bike':	                    {codePoint: 0xF00A3, xoffs:0, yoffs:0, pad: 0},
    'mdi-bike-fast':	            {codePoint: 0xF111F, xoffs:0, yoffs:0, pad: 0},
    'mdi-tools':	                {codePoint: 0xF1064, xoffs:0, yoffs:0, pad: 0},
    'mdi-hammer-screwdriver':	    {codePoint: 0xF1322, xoffs:0, yoffs:0, pad: 0},
    'mdi-hammer-wrench':	        {codePoint: 0xF1323, xoffs:0, yoffs:0, pad: 0},
    'mdi-wrench':	                {codePoint: 0xF05B7, xoffs:0, yoffs:0, pad: 0},
    'mdi-gas-station':	            {codePoint: 0xF0298, xoffs:0, yoffs:0, pad: 0},
    
    // First aid, Medical
    
    'mdi-medical-bag':	            {codePoint: 0xF06EF, xoffs:0, yoffs:0, pad: 0},
    'mdi-hospital-box':	            {codePoint: 0xF02E0, xoffs:0, yoffs:0, pad: 0},
    'mdi-hospital-box-outline':	    {codePoint: 0xF0FF7, xoffs:0, yoffs:0, pad: 8},
    'mdi-stethoscope':	            {codePoint: 0xF04D9, xoffs:0, yoffs:0, pad: 0},
    
    // Food, drink, refreshments
    
    'mdi-food':	                    {codePoint: 0xF025A, xoffs:0, yoffs:0, pad: 0},
    'mdi-food-fork-drink':	        {codePoint: 0xF05F2, xoffs:0, yoffs:0, pad: 0},
    'mdi-pizza':	                {codePoint: 0xF0409, xoffs:0, yoffs:0, pad: 0},
    'mdi-cupcake':	                {codePoint: 0xF095A, xoffs:0, yoffs:0, pad: 0},
    'mdi-cup':	                    {codePoint: 0xF01AA, xoffs:0, yoffs:0, pad: 0},
    'mdi-coffee':                   {codePoint: 0xF0176, xoffs:0, yoffs:0, pad: 0},
    'mdi-tea':	                    {codePoint: 0xF0D9E, xoffs:0, yoffs:0, pad: 0},
    'mdi-glass-mug':	            {codePoint: 0xF02A6, xoffs:0, yoffs:0, pad: 0},
    'mdi-glass-mug-variant':        {codePoint: 0xF1116, xoffs:0, yoffs:0, pad: 0},
    'mdi-beer':	                    {codePoint: 0xF0098, xoffs:0, yoffs:0, pad: 0},
    'mdi-glass-cocktail':	        {codePoint: 0xF0356, xoffs:0, yoffs:0, pad: 0},
    'mdi-glass-wine':	            {codePoint: 0xF0876, xoffs:0, yoffs:0, pad: 0},
    'mdi-silverware-fork-knife':    {codePoint: 0xF0A70, xoffs:0, yoffs:0, pad: 0},
    'mdi-silverware-variant':       {codePoint: 0xF04A6, xoffs:0, yoffs:0, pad: 0},
    
    // Travel & accommodation
    
    'mdi-bed':	                    {codePoint: 0xF02E3, xoffs:0, yoffs:0, pad: 0},
    'mdi-home':	                    {codePoint: 0xF02DC, xoffs:0, yoffs:0, pad: 0},
    'mdi-airplane':	                {codePoint: 0xF001D, xoffs:0, yoffs:0, pad: 0},
    'mdi-car-hatchback':	        {codePoint: 0xF07A9, xoffs:0, yoffs:0, pad: 2},
    'mdi-train':	                {codePoint: 0xF052C, xoffs:0, yoffs:0, pad: 2},
    'mdi-ferry':	                {codePoint: 0xF0213, xoffs:0, yoffs:0, pad: 0},
    
    // Numbered & lettered labels
    
    
    'mdi-numeric-1-circle':	        {codePoint: 0xF0CA0, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-2-circle':	        {codePoint: 0xF0CA2, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-3-circle':	        {codePoint: 0xF0CA4, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-4-circle':	        {codePoint: 0xF0CA6, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-5-circle':	        {codePoint: 0xF0CA8, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-6-circle':	        {codePoint: 0xF0CAA, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-7-circle':	        {codePoint: 0xF0CAC, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-8-circle':	        {codePoint: 0xF0CAE, xoffs:0, yoffs:0, pad: 2},
    'mdi-numeric-9-circle':	        {codePoint: 0xF0CB0, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-a-circle':	        {codePoint: 0xF0BEC, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-b-circle':	        {codePoint: 0xF0BEF, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-c-circle':	        {codePoint: 0xF0BF2, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-d-circle':	        {codePoint: 0xF0BF5, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-e-circle':	        {codePoint: 0xF0BF8, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-f-circle':	        {codePoint: 0xF0BFB, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-x-circle':	        {codePoint: 0xF0C31, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-y-circle':	        {codePoint: 0xF0C34, xoffs:0, yoffs:0, pad: 2},
    'mdi-alpha-z-circle':	        {codePoint: 0xF0C37, xoffs:0, yoffs:0, pad: 2}
 
}